import { combineReducers } from 'redux';

import necessaryData from './requests/necessary-data-preparing-req';
import acceptConsent from './requests/accept-consent-req';
import careUsers from './requests/care-users-req';
import userDetails from './requests/user-details-req';
import visitTypes from './requests/visit-types-req';
import reasonTypes from './requests/reason-types-req';
import reasonVisit from './requests/reason-visit-req';
import inspection from './requests/inspection-req';
import inspectConsent from './requests/inspect-consent-form';
import inspectPatient from './requests/inspect-patient-form';
import providerGWDetails from './requests/provider-GW-details-req';
import primaryProviderData from './requests/primary-provider-data';
import providerDetails from './requests/provider-details-req';
import schedulings from './requests/schedulings-req';
import programBasedVisits from './requests/program-based-visits-req';
import availableProvidersSelfScheduling from './requests/available-providers-self-scheduling';
import confirmVisitSelfScheduling from './requests/confirm-visit-selfScheduling-req';
import confirmVisitUrgent from './requests/confirm-visit-urgent-req';
import organizations from './requests/organizations-req';
import confirmVisitGW from './requests/confirm-visit-GW-req';
import filterList from './requests/filters-req';
import consent from './requests/consent-req';
import insurancePayers from './requests/insurance-payers-req';
import checkInsuranceEligibility from './requests/check-insurance-eligibility';
import checkInsurancePlanConfig from './requests/check-insurance-plan-config-req';
import latestCheckInsuranceEligibility from './requests/latest-check-insurance-req';
import virtualVisitProviders from './requests/virtual-visit-providers-req';
import publixInfo from './requests/publix-info-req';
import createVirtualVisit from './requests/create-virtual-visit-req';
import inspectVirtualVisit from './requests/inspection-virtual-visit-form';
import insuranceErrorModal from './handle-insurance-error-modal';
import overlapModal from './overlap-modal';
import progress from './progress';
import filters from './filters';
import pharmaciesList from './requests/pharmacy-req';
import medicationsList from './requests/medications-req';
import inlineVisitTimeSlots from './requests/inline-visits-time-slots';
import confirmInlineVisit from './requests/confirm-inline-visit';
import schedulingTree from './requests/schedulable-tree-req';
import myProviders from './requests/my-providers-req';
import fetchCopay from './requests/fetch-copay';
import availableEirLocations from './requests/available-eir-locations';
import createEirUrgentCareAppointment from './requests/create-eir-urgent-care-appointment';
import primaryCareProvidersList from './requests/primary-providers-list';
import employersList from './requests/organization-employers-list';
import appointmentPaymentInfoModal from './appointment-payment-info-modal';

export default combineReducers({
  careUsers,
  acceptConsent,
  visitTypes,
  reasonTypes,
  reasonVisit,
  userDetails,
  progress,
  filters,
  inspection,
  schedulings,
  availableProvidersSelfScheduling,
  confirmVisitSelfScheduling,
  confirmVisitUrgent,
  providerGWDetails,
  primaryProviderData,
  providerDetails,
  confirmVisitGW,
  organizations,
  filterList,
  consent,
  inspectConsent,
  inspectPatient,
  necessaryData,
  virtualVisitProviders,
  publixInfo,
  createVirtualVisit,
  inspectVirtualVisit,
  overlapModal,
  programBasedVisits,
  insurancePayers,
  checkInsurancePlanConfig,
  checkInsuranceEligibility,
  insuranceErrorModal,
  latestCheckInsuranceEligibility,
  pharmaciesList,
  medicationsList,
  inlineVisitTimeSlots,
  confirmInlineVisit,
  schedulingTree,
  myProviders,
  fetchCopay,
  availableEirLocations,
  createEirUrgentCareAppointment,
  primaryCareProvidersList,
  employersList,
  appointmentPaymentInfoModal,
});



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/index.js